import { Radar, Line, Bar, Doughnut } from "react-chartjs-2";
import {
    formatNumberDecimal,
    formatDateMoment,
    formatPercentage
} from "./utils";
  
export const graphicRadar = "radar";
export const graphicBar = "bar";
export const graphicLine = "line";
export const graphicDoughnut = "doughnut";

export const typesGraphic:any = {
    [graphicRadar]: Radar,
    [graphicBar]: Bar,
    [graphicLine]: Line,
    [graphicDoughnut]: Doughnut,
};
  
const GRAPHIC_IDS = {
    BAR: 1,
    LINE: 2,
    RADAR: 3,
    HORIZONTALBAR: 4,
    DOUGHNUT: 16
};

export const tooltipsGraphic = (graphicId:any, currency:any) => {
    switch (graphicId) {
        case GRAPHIC_IDS.BAR: {
            return {
            title: (tooltipItem:any) => tooltipItem[0].yLabel,
            label: (tooltipItem:any, data:any) => `${tooltipItem.xLabel}`
            };
        }
        case GRAPHIC_IDS.LINE: {
            return {
                title: (tooltipItem:any, data:any) => {
                    const date = data.labels[tooltipItem[0].index].split("|");
                    return `${
                    tooltipItem.length > 1
                        ? data.labels[tooltipItem[0].index]
                        : date[tooltipItem[0].datasetIndex]
                    }`;
                },
                label: (tooltipItem:any, data:any) =>
                    `${
                    data.datasets[tooltipItem.datasetIndex].label
                    }: ${currency} ${formatNumberDecimal(tooltipItem.yLabel)}`,
                afterLabel: (tooltipItem:any, data:any) => {
                    const dataSetsValues = data.datasets.map((dataSet:any) =>
                        parseInt(dataSet.data[tooltipItem.index], 10)
                    );
                    const percent =
                    (dataSetsValues.reduce((acum = 0, value:any) => acum / value) - 1) *
                    100;
                    return tooltipItem.datasetIndex === data.datasets.length - 1 &&
                    !isNaN(percent) &&
                    percent !== Infinity
                    ? `${formatPercentage(percent.toFixed(1))}%`
                    : null;
                }
            };
        }
        default: {
            return [];
        }
    }
};

export const graphicRadarOptions = (graphicId:any) => {
    const optionGraphic = {
        responsive: true,
        tooltips: {
            mode: "x",
            intersect: false,
            callbacks: tooltipsGraphic(graphicId,null)
        },
        hover: {
            mode: "x",
            intersect: false
        },
        legend: { display: false },
        scales: {
            xAxes: [
            {
                ticks: {
                callback: (value:any) => {
                    const date = value.split(" | ");
                    return formatDateMoment(date[0], "DD-MM-YYYY", "DD-MM-YY");
                }
                }
            }
            ]
        }
    };
    return optionGraphic;
};
  
export const graphicLineOptions = (graphicId:any) => {
    const optionGraphic = {
        responsive: true,
        tooltips: {
            mode: "x",
            intersect: false,
            callbacks: tooltipsGraphic(graphicId,null)
        },
        hover: {
            mode: "x",
            intersect: false
        }
    };
    return optionGraphic;
};

export const graphicDoughnutOptions = (graphicId:any) => {
    const optionGraphic = {
      responsive: true,
      legend: { display: false }
    };
    return optionGraphic;
};
  
export function optionsForGraphic(type:any, graphicId:any, currency:any) {
    switch (type) {
        case graphicRadar: {
            return graphicRadarOptions(graphicId);
        }
        case graphicLine: {
            return graphicLineOptions(graphicId);
        }
        case graphicDoughnut: {
            return graphicDoughnutOptions(graphicId);
        }
        default: {
            return {};
        }
    }
}


  